import { render, staticRenderFns } from "./FormTechnologicalDevelopmentsPg.vue?vue&type=template&id=725e4cd8&scoped=true&"
import script from "./FormTechnologicalDevelopmentsPg.vue?vue&type=script&lang=js&"
export * from "./FormTechnologicalDevelopmentsPg.vue?vue&type=script&lang=js&"
import style0 from "./FormTechnologicalDevelopmentsPg.vue?vue&type=style&index=0&id=725e4cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725e4cd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VFileInput,VForm,VRow,VTextField})
